import { render, staticRenderFns } from "./GraficaProductividad.vue?vue&type=template&id=1558b8c4"
import script from "./GraficaProductividad.vue?vue&type=script&lang=js"
export * from "./GraficaProductividad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports